var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-layout',{staticClass:"items-center",class:{ 'page-scrolled':_vm.pageScrolled },attrs:{"view":"hHh lpr fff"},on:{"scroll":_vm.onScroll}},[_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }